export function CalendarLegend({
  plantFilter = "0",
  statusFilter = "",
}: {
  plantFilter?: string;
  statusFilter?: string;
}) {
  const useDefaultColors = plantFilter === "0" && statusFilter === "";

  return (
    <div className="tw-mt-4 tw-text-xs tw-text-gray-600 dark:tw-text-gray-300">
      {useDefaultColors ? (
        <div>
          <div className="tw-mb-1 tw-font-semibold">
            Colors indicate status and request type:
          </div>
          <div className="tw-flex tw-flex-wrap tw-gap-x-4 tw-gap-y-1">
            <div className="tw-flex tw-items-center tw-gap-1">
              <span className="tw-inline-block tw-w-3 tw-h-3 tw-bg-yellow-300 tw-rounded"></span>
              <span>Vacation Pending</span>
            </div>
            <div className="tw-flex tw-items-center tw-gap-1">
              <span className="tw-inline-block tw-w-3 tw-h-3 tw-bg-green-600 tw-rounded"></span>
              <span>Approved</span>
            </div>
            <div className="tw-flex tw-items-center tw-gap-1">
              <span className="tw-inline-block tw-w-3 tw-h-3 tw-bg-red-600 tw-rounded"></span>
              <span>Rejected/Cancelled</span>
            </div>
            <div className="tw-flex tw-items-center tw-gap-1">
              <span className="tw-inline-block tw-w-3 tw-h-3 tw-bg-blue-400 tw-rounded"></span>
              <span>Sick Pending</span>
            </div>
          </div>
        </div>
      ) : (
        <div>
          Colors indicate the contractor. Status is shown in the bar text.
        </div>
      )}
    </div>
  );
}
